import type { BillingDayOption } from '../billing-cycle-types/billing-day-option';

const getBillingDayOptions = (): BillingDayOption[] => {
  const arr = [];
  for (let i = 1; i <= 25; i++) {
    let suffix = 'th';
    if (i % 10 === 1 && i !== 11) {
      suffix = 'st';
    } else if (i % 10 === 2 && i !== 12) {
      suffix = 'nd';
    } else if (i % 10 === 3 && i !== 13) {
      suffix = 'rd';
    }
    arr.push({
      value: i,
      label: `${i}${suffix}`,
    });
  }

  return arr;
};

export const billingDayOptions: BillingDayOption[] = getBillingDayOptions();